import React from 'react';
import styled, { css } from 'styled-components';

import { Theme } from '~/theme';

type Props = {
  /** for tests */
  dataTestid?: string;

  /** when clicked */
  onClick?: () => void;

  /** Card content */
  children: React.ReactNode;
};

const Card: React.FC<Props> = ({ dataTestid, ...props }) => (
  <CardElement data-testid={dataTestid} {...props} />
);

export const getCardPadding = (theme: Theme) => theme.space('l');
export const getCardRadius = (theme: Theme) =>
  theme.getTokens().border.radius.s;

type CardElementProps = {
  onClick?: () => void;
};
const CardElement = styled.div<CardElementProps>`
  position: relative;
  transition: box-shadow 0.2s linear;

  ${({ theme }) => css`
    border-radius: ${getCardRadius(theme)};
    background-color: ${theme.color('white')};
    box-shadow: ${theme.getTokens().boxShadow.card};
    padding: ${theme.space('l')} ${getCardPadding(theme)};
    margin-bottom: ${theme.space('m')};

    &:hover {
      box-shadow: ${theme.getTokens().boxShadow.cardHover};
    }
  `};

  ${({ onClick }) => {
    if (onClick) {
      return css`
        cursor: pointer;
      `;
    }
    return ``;
  }}
`;

export default Card;
